import { render, staticRenderFns } from "./PrkBeamSyllabusesNew.vue?vue&type=template&id=4d942ea8&scoped=true&"
import script from "./PrkBeamSyllabusesNew.vue?vue&type=script&lang=js&"
export * from "./PrkBeamSyllabusesNew.vue?vue&type=script&lang=js&"
import style0 from "./PrkBeamSyllabusesNew.vue?vue&type=style&index=0&id=4d942ea8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d942ea8",
  null
  
)

export default component.exports